import apiClient from '../config/api';

let profile = null;
let pending = null;
let pendingUsername = null;
let generation = 0;
const listeners = new Set();
const publish = () => listeners.forEach((listener) => listener());
export const getCurrentProfile = () => profile;
export const subscribeCurrentProfile = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const clearCurrentProfile = () => {
  generation += 1;
  pending = null;
  profile = null;
  publish();
};
export const setCurrentProfile = (value) => {
  generation += 1;
  pending = null;
  profile = value?.username ? value : null;
  publish();
};
export const loadCurrentProfile = (expectedUsername) => {
  const expected = String(expectedUsername || '').trim().toLowerCase();
  if (profile && expected && profile.username.toLowerCase() !== expected) clearCurrentProfile();
  if (pending && expected && pendingUsername !== expected) clearCurrentProfile();
  if (profile) return Promise.resolve(profile);
  if (pending) return pending;
  const version = generation;
  pendingUsername = expected;
  const request = apiClient.get('/auth/session').then(({ data }) => {
    if (version !== generation) return null;
    // Never publish a response for a different account than the requested one.
    if (!data?.username || (expected && data.username.toLowerCase() !== expected)) return null;
    profile = data;
    publish();
    return profile;
  }).finally(() => { if (pending === request) pending = null; });
  pending = request;
  return request;
};
